import React, { useEffect, useState } from "react";
import { LOGO_URL } from "../lib/api";
import { Link } from "react-router-dom";

const STORAGE_KEY = "sa_age_confirmed_v1";

const AgeGate = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const ok = localStorage.getItem(STORAGE_KEY);
      if (!ok) setOpen(true);
    } catch (e) {
      // localStorage unavailable (Safari private mode) → fail-closed, show gate
      setOpen(true);
    }
  }, []);

  const confirm = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {
      // ignore: storage may be disabled; gate will reappear next visit
    }
    setOpen(false);
  };
  const reject = () => {
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[999] flex items-center justify-center px-4"
      style={{ background: "rgba(20, 22, 18, 0.92)", backdropFilter: "blur(8px)" }}
    >
      <div className="max-w-md w-full bg-[#FAF9F6] rounded-2xl shadow-2xl p-8 text-center border border-[#D4AF37]/30">
        <img src={LOGO_URL} alt="Secret Angels" className="h-24 w-24 mx-auto object-contain" />
        <div className="text-xs tracking-[0.35em] uppercase text-[#6B6A63] mt-3">Aviso de edad</div>
        <h2 className="font-serif text-3xl text-[#1A2118] mt-2">Solo para mayores de 18 años</h2>
        <p className="text-sm text-[#6B6A63] mt-4 leading-relaxed">
          Este sitio contiene contenido para adultos. Al ingresar declaras que <strong>tienes al menos 18 años</strong>
          {" "}y que es legal acceder a este tipo de contenido en tu jurisdicción.
        </p>
        <p className="text-xs text-[#6B6A63] mt-3">
          Al continuar, aceptas nuestros{" "}
          <Link to="/terminos" className="underline">Términos y Condiciones</Link>
          {" "}y nuestra{" "}
          <Link to="/privacidad" className="underline">Política de Privacidad</Link>.
        </p>
        <div className="grid grid-cols-2 gap-3 mt-6">
          <button data-testid="age-gate-reject" onClick={reject} className="btn-ghost text-sm">
            Soy menor — Salir
          </button>
          <button data-testid="age-gate-accept" onClick={confirm} className="btn-primary text-sm">
            Tengo 18+ — Entrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
